/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { SystemVarsSalesDto } from '@gh/builder-shared-data';

export type SystemVarsSales = SystemVarsSalesDto;

export const systemVarsSalesFromDto = (dto: SystemVarsSalesDto) => <SystemVarsSales>({
  ...dto,
  rfqParagraph1: dto.rfqParagraph1 ? dto.rfqParagraph1 : '',
  rfqParagraph2: dto.rfqParagraph2 ? dto.rfqParagraph2 : '',
});
